module.exports = __webpack_public_path__ + "media/components/page-footer/static/surf-forecast__logo--white-efd8b546d6bda896ae20f0197efb4ee5.png";